import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGraphBar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16.932 3.101c0-.418.19-.57.609-.57h5.365c.419 0 .609.152.609.57V28.9c0 .342-.19.57-.609.57h-5.365c-.418 0-.609-.228-.609-.57zm8.447 7.8c0-.342.19-.532.61-.532h5.478c.343 0 .533.19.533.532V28.9c0 .342-.19.57-.533.57h-5.479c-.418 0-.609-.228-.609-.57zM0 10.901c0-.342.19-.532.609-.532h5.403c.418 0 .57.19.57.532V28.9c0 .342-.152.57-.57.57H.609C.19 29.47 0 29.242 0 28.9zm8.447 9.589c0-.419.19-.609.609-.609h5.403c.418 0 .609.19.609.609v8.409c0 .342-.19.57-.609.57H9.056c-.419 0-.609-.228-.609-.57z" /></svg>;
export default SvgGraphBar;